import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';
import { motion } from 'framer-motion';

import { LoaderProps } from './loader.types';

const textContainer = {
  animate: {
    scale: [0.75, 1, 0.75, 1, 0.75, 0.75],
    transition: {
      duration: 1,
      repeat: Infinity
    }
  }
};

const Loader: React.FC<LoaderProps> = ({ isFloating = false, isVisible }) => {
  const motionClassName = classNames(
    isFloating ? 'absolute' : 'fixed',
    'inset-0 z-30 m-auto size-20'
  );

  return (
    <>
      {isVisible && (
        <motion.div
          data-testid="page_loader"
          className={motionClassName}
          initial="initial"
          animate="animate"
          variants={textContainer}
        >
          <Common.Icon name="lifemd" className="size-full" />
        </motion.div>
      )}
    </>
  );
};

export default Loader;
